export const transformObjectId = (object?: any): string => {
  return transformId(object?.['@id']);
};

export const transformId = (relationUri?: string): string => {
  if (!relationUri) return '';
  return relationUri.split('/')[3];
};
